var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#333a48;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.875,3.75A7.125,7.125,0,1,0,18,10.875,7.125,7.125,0,0,0,10.875,3.75ZM2.25,10.875A8.625,8.625,0,1,1,10.875,19.5,8.625,8.625,0,0,1,2.25,10.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.913,15.913a.75.75,0,0,1,1.061,0L21.53,20.47A.75.75,0,0,1,20.47,21.53l-4.556-4.556A.75.75,0,0,1,15.913,15.913Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.bb23e0d8830b4f235e47cdd87fb06c0a.svg";
export { ForwardRef as ReactComponent };